export default __webpack_public_path__ + "../staticImages/advent-calendar-footer--mobile.png";